export enum ESearchWizardSteps {
  SEARCH = "search",
  RESULTS = "results",
  DETAIL = "detail",
}
